// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicCardTypeControllerGetAllData } from './PublicCardTypeControllerGetAllData.gen';
import type { PublicCardTypeControllerGetAllErrors } from './PublicCardTypeControllerGetAllErrors.gen';
import type { PublicCardTypeControllerGetAllResponses } from './PublicCardTypeControllerGetAllResponses.gen';
import type { PublicCardTypeControllerGetThirdPartyCardTypesData } from './PublicCardTypeControllerGetThirdPartyCardTypesData.gen';
import type { PublicCardTypeControllerGetThirdPartyCardTypesErrors } from './PublicCardTypeControllerGetThirdPartyCardTypesErrors.gen';
import type { PublicCardTypeControllerGetThirdPartyCardTypesResponses } from './PublicCardTypeControllerGetThirdPartyCardTypesResponses.gen';

export class PublicCardTypeController {
    /**
     * Get card types
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicCardTypeControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCardTypeControllerGetAllResponses, PublicCardTypeControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/card-types',
            ...options
        });
    }
    
    /**
     * Get third party card types
     */
    public static getThirdPartyCardTypes<ThrowOnError extends boolean = false>(options?: Options<PublicCardTypeControllerGetThirdPartyCardTypesData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicCardTypeControllerGetThirdPartyCardTypesResponses, PublicCardTypeControllerGetThirdPartyCardTypesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/card-types/third-party',
            ...options
        });
    }
}
